import { render } from "./InfoBasicasRA.vue?vue&type=template&id=dce7cc0c&scoped=true"
import script from "./InfoBasicasRA.vue?vue&type=script&lang=js"
export * from "./InfoBasicasRA.vue?vue&type=script&lang=js"

import "./InfoBasicasRA.vue?vue&type=style&index=0&id=dce7cc0c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce7cc0c"]])

export default __exports__